import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Card } from "antd";
import MaterialTable from "material-table";
import { GetRevenueReportByID } from "../../../api";
import { useParams } from "react-router-dom";

const SingleRevenueReport = () => {
  const { id } = useParams();

  const [purchasesNo, setpurchasesNo] = useState(0);
  const [refundNo, setrefundNo]       = useState(0);
  const [timePeriod, settimePeriod]   = useState("");
  const [purchasedData, setpurchasedData] = useState([]);
  const [refundData, setrefundData]   = useState([]);

  useEffect(() => {
    GetRevenueReportByID(id, setrefundNo, setpurchasesNo, setpurchasedData, settimePeriod, setrefundData);
  }, [id]);

  const headerCellStyle = { fontWeight: "bold" };

  const css = `
    /* ── breadcrumb / header ── */
    .srv-header {
      display: flex; align-items: center; gap: 10px;
      margin-bottom: 20px; flex-wrap: wrap;
    }
    .srv-back-btn {
      display: flex; align-items: center; gap: 6px;
      background: #fff; border: 1.5px solid #e2e8f0; border-radius: 8px;
      padding: 6px 12px; font-size: 12.5px; font-weight: 600; color: #64748b;
      cursor: pointer; font-family: inherit; transition: all 0.13s; text-decoration: none;
    }
    .srv-back-btn:hover { border-color: #94a3b8; color: #1e293b; }
    .srv-breadcrumb-sep { color: #cbd5e1; font-size: 14px; }
    .srv-page-title {
      font-family: 'Syne', sans-serif; font-size: 20px; font-weight: 800;
      color: #0f172a; letter-spacing: -0.02em; margin: 0;
    }
    .srv-period-badge {
      background: #f1f5f9; border: 1.5px solid #e2e8f0; border-radius: 20px;
      padding: 3px 12px; font-size: 12px; font-weight: 700; color: #475569;
      letter-spacing: 0.02em;
    }

    /* ── stat pills ── */
    .srv-stats { display: flex; gap: 10px; margin-bottom: 16px; flex-wrap: wrap; }
    .srv-stat {
      background: #fff; border: 1.5px solid #f1f5f9; border-radius: 12px;
      padding: 14px 20px; display: flex; align-items: center; gap: 12px;
      box-shadow: 0 1px 4px rgba(15,23,42,0.04); flex: 1; min-width: 160px;
    }
    .srv-stat-icon {
      width: 36px; height: 36px; border-radius: 9px;
      display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0;
    }
    .srv-stat-label { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.08em; color: #94a3b8; margin: 0; }
    .srv-stat-value { font-family: 'Syne', sans-serif; font-size: 20px; font-weight: 800; color: #0f172a; margin: 1px 0 0; letter-spacing: -0.02em; }

    /* ── card ── */
    .srv-card {
      background: #fff; border: 1.5px solid #f1f5f9 !important;
      border-radius: 14px !important; box-shadow: 0 1px 6px rgba(15,23,42,0.05) !important;
      overflow: hidden;
    }
    .srv-card .ant-card-body { padding: 0 !important; }

    /* ── tabs ── */
    .srv-root .nav-tabs {
      border-bottom: 1.5px solid #f1f5f9 !important;
      padding: 0 18px; background: #f8fafc; gap: 4px;
    }
    .srv-root .nav-tabs .nav-link {
      border: none !important; border-bottom: 2.5px solid transparent !important;
      border-radius: 0 !important; padding: 14px 16px 12px !important;
      font-family: 'DM Sans', sans-serif !important; font-size: 13px !important;
      font-weight: 600 !important; color: #94a3b8 !important;
      transition: all 0.15s !important; background: transparent !important;
      margin-bottom: -1.5px !important;
    }
    .srv-root .nav-tabs .nav-link:hover { color: #475569 !important; }
    .srv-root .nav-tabs .nav-link.active {
      color: #0f172a !important; border-bottom-color: #0f172a !important;
      background: transparent !important;
    }
    .srv-root .tab-content { padding: 0; }

    /* tab label layout */
    .srv-tab-label { display: flex; flex-direction: row; align-items: center; gap: 7px; }
    .srv-tab-name { font-size: 13px; font-weight: 700; color: inherit; white-space: nowrap; }
    .srv-tab-count {
      font-size: 11px; font-weight: 600; color: #94a3b8;
      background: #f1f5f9; border-radius: 20px; padding: 1px 7px;
    }
    .srv-root .nav-tabs .nav-link.active .srv-tab-count { background: #e2e8f0; color: #475569; }

    /* ── MUI / MaterialTable overrides ── */
    .srv-root .MuiPaper-root { box-shadow: none !important; border-radius: 0 !important; }
    .srv-root .MuiToolbar-root {
      padding: 10px 16px !important; background: #fff !important;
      border-bottom: 1.5px solid #f1f5f9 !important; min-height: 52px !important;
    }
    .srv-root h6.MuiTypography-root {
      font-family: 'Syne', sans-serif !important; font-size: 13px !important;
      font-weight: 800 !important; color: #1e293b !important; letter-spacing: -0.01em !important;
    }
    .srv-root .MuiTableHead-root th {
      background: #f8fafc !important; font-size: 10.5px !important; font-weight: 700 !important;
      color: #94a3b8 !important; text-transform: uppercase !important; letter-spacing: 0.06em !important;
      border-bottom: 1.5px solid #f1f5f9 !important; font-family: 'DM Sans', sans-serif !important;
      white-space: nowrap;
    }
    .srv-root .MuiTableBody-root td {
      font-size: 12.5px !important; color: #334155 !important;
      border-bottom: 1px solid #f8fafc !important; font-family: 'DM Sans', sans-serif !important;
    }
    .srv-root .MuiTableBody-root tr:hover td { background: #f8fafc !important; }
    .srv-root .MuiTableFooter-root td { font-family: 'DM Sans', sans-serif !important; }
    .srv-root .MuiInputBase-input { font-family: 'DM Sans', sans-serif !important; font-size: 13px !important; }

    /* refund amount highlight */
    .srv-refund-neg { color: #dc2626 !important; font-weight: 600 !important; }

    /* animations */
    @keyframes srv-in { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:none; } }
    .srv-s1 { animation: srv-in 0.3s ease forwards 0.04s; opacity:0; }
    .srv-s2 { animation: srv-in 0.3s ease forwards 0.11s; opacity:0; }
    .srv-s3 { animation: srv-in 0.3s ease forwards 0.18s; opacity:0; }
  `;

  return (
    <div className="all-courses-container mb-4 srv-root">
      <style>{css}</style>

      {/* ── Header ── */}
      <div className="srv-header srv-s1">
        <a href="/performance/revenue-report" className="srv-back-btn">
          ← Revenue Reports
        </a>
        <span className="srv-breadcrumb-sep">/</span>
        <h1 className="srv-page-title">Monthly Report</h1>
        {timePeriod && <span className="srv-period-badge">{timePeriod}</span>}
      </div>

      {/* ── Stat pills ── */}
      <div className="srv-stats srv-s2">
        <div className="srv-stat">
          <div className="srv-stat-icon" style={{ background: "#dbeafe" }}>🛒</div>
          <div>
            <p className="srv-stat-label">Purchases</p>
            <p className="srv-stat-value">{purchasesNo}</p>
          </div>
        </div>
        <div className="srv-stat">
          <div className="srv-stat-icon" style={{ background: "#fee2e2" }}>↩</div>
          <div>
            <p className="srv-stat-label">Refunds</p>
            <p className="srv-stat-value">{refundNo}</p>
          </div>
        </div>
        <div className="srv-stat">
          <div className="srv-stat-icon" style={{ background: "#dcfce7" }}>📅</div>
          <div>
            <p className="srv-stat-label">Period</p>
            <p className="srv-stat-value" style={{ fontSize: 15 }}>{timePeriod || "—"}</p>
          </div>
        </div>
      </div>

      {/* ── Tabs card ── */}
      <Card className="srv-card srv-s3">
        <Tabs>
          <Tab
            eventKey="home"
            title={
              <div className="srv-tab-label">
                <span className="srv-tab-name">Purchases</span>
                <span className="srv-tab-count">{purchasesNo} this month</span>
              </div>
            }
          >
            <MaterialTable
              title="Total Revenue"
              columns={[
                { title: "Date",                    field: "date",                  headerStyle: headerCellStyle },
                { title: "Customer Name",           field: "customerName",          headerStyle: headerCellStyle },
                { title: "Course",                  field: "course",                headerStyle: headerCellStyle },
                { title: "Coupon Code",             field: "couponCode",            headerStyle: headerCellStyle },
                { title: "Price Paid",              field: "pricePaid",             headerStyle: headerCellStyle },
                { title: "Price Paid (GBP)",        field: "pricePaidGBP",          headerStyle: headerCellStyle },
                { title: "Processing Fees",         field: "paymentProcessingFees", headerStyle: headerCellStyle },
                // { title: "Apple/Google Fees ($)",   field: "appleOrGoogleFees",     headerStyle: headerCellStyle },
                { title: "Tax",                     field: "tax",                   headerStyle: headerCellStyle },
                { title: "Net Revenue",             field: "netRevenue",            headerStyle: headerCellStyle },
                { title: "Your Revenue",            field: "yourRevenue",           headerStyle: headerCellStyle,
                  render: row => <span style={{ color: "#16a34a", fontWeight: 700 }}>{row.yourRevenue}</span> },
                { title: "Channel",                 field: "channel",               headerStyle: headerCellStyle },
                { title: "Platform",                field: "platform",              headerStyle: headerCellStyle },
              ]}
              data={purchasedData}
              options={{
                sorting: true,
                exportButton: true,
                rowStyle: { fontSize: "12.5px" },
                headerStyle: { fontSize: "11px", fontWeight: 700 },
                cellStyle: { paddingLeft: "0.75rem", paddingRight: "0.5rem" },
              }}
            />
          </Tab>

          <Tab
            eventKey="refunds"
            title={
              <div className="srv-tab-label">
                <span className="srv-tab-name">Refunds</span>
                <span className="srv-tab-count">{refundNo} this month</span>
              </div>
            }
          >
            <MaterialTable
              title="All Refunds"
              columns={[
                { title: "Date",                    field: "date",                  headerStyle: headerCellStyle },
                { title: "Customer Name",           field: "customerName",          headerStyle: headerCellStyle },
                { title: "Course",                  field: "course",                headerStyle: headerCellStyle },
                { title: "Refund Amount",           field: "refundsAmount",         headerStyle: headerCellStyle,
                  render: row => <span className="srv-refund-neg">{row.refundsAmount}</span> },
                { title: "Change to Your Revenue",  field: "changeToYourRevenue",   headerStyle: headerCellStyle,
                  render: row => <span className="srv-refund-neg">{row.changeToYourRevenue}</span> },
              ]}
              data={refundData}
              options={{
                sorting: true,
                exportButton: true,
                rowStyle: { fontSize: "12.5px" },
                headerStyle: { fontSize: "11px", fontWeight: 700 },
              }}
            />
          </Tab>
        </Tabs>
      </Card>
    </div>
  );
};

export default SingleRevenueReport;

